import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONFIG } from '../../constants/constants';
import { ExamEvaluation, ExamEvaluationConfigurationDTO, ExamEvaluationValidationResponse, ExamItemEvaluation } from '../../model/exam-evaluation-configuration';
import { Answer } from '../../model/answer';
import { AnswerControlService } from '../answer/answerControl.service';
import { VisualizerComponent } from '../../pages/visualizer/visualizer.component';
import { WelcomeService } from '../welcome/welcome.service';

//Variable del global scope para utilizar jquery
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ExamEvaluationConfService {


  examEvaluationConf: ExamEvaluationConfigurationDTO[] = [];
  listaValorReferencia: ExamEvaluationConfigurationDTO[] = [];
  listaElementosValoracion: ExamEvaluationConfigurationDTO[] = [];
  listaElementosEvaluar: ExamEvaluationConfigurationDTO[] = [];
  listaRespuestasExtendias: ExamEvaluationConfigurationDTO[] = [];
  listaRespuestaMaterial: ExamEvaluationConfigurationDTO[] = [];
  listaEnunciados: ExamEvaluationConfigurationDTO[] = [];
  answersForEvaluation: number;
  EXAM_EVAL_DEFAULT_SELECT = 'Seleccione';

  public visualizerComponent: VisualizerComponent;

  //variable para controlar en el formulario las respuestas de la evaluación
  public arrayObject: ExamEvaluation;
  public oriArrayObject: ExamEvaluation;

  //variable para controlar la apertura del mensaje indicando desconexión
  controlMessageInfo: boolean;

  //constructor de la clase
  constructor(private http: HttpClient,
    public _answerController: AnswerControlService,
    public _welcomeDataService: WelcomeService, ) {
    this.http = http;
  }

  public getExamEvaluationConf(user: string, token: string, apliId: string): Promise<ExamEvaluationConfigurationDTO[]> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'user': user,
    });

    return this.http.get<ExamEvaluationConfigurationDTO[]>(CONFIG.REST_END_POINT + 'getExamEvaluationConf?apliId=' + apliId,
      { headers: _headers })
      .toPromise();
  }

  /*Se encarga de enviar a guardar la respuesta de la evaluacion del item, y la respuesta del item*/
  private saveExamEvaluation(token: string, answer: Answer, user: string): Promise<any> {

    if (answer.respuestaAbierta != null) {
      const formData = new FormData();
      if (token) {
        const _headers = new HttpHeaders({
          'token': token,
          'user': user
        });

        answer.respuestaAbierta = this.convertirTildesAHtml(answer.respuestaAbierta);

        formData.append("data", JSON.stringify(answer));

        const options: {
          headers?: HttpHeaders,
          observe?: 'body',
          params?: HttpParams,
          reportProgress?: boolean,
          responseType: 'text',
          withCredentials?: boolean
        } = {
          headers: _headers,
          responseType: 'text'
        };
        return this.http.post(CONFIG.REST_END_POINT + 'saveExamEvaluation/',
          formData, options).toPromise();
      }
    }
  }

  //retorna la evaluación para el item
  public getLocalStorage(itemIdActual): Object {
    const jsonString = localStorage.getItem('EXAM_VAL_' + itemIdActual);
    return JSON.parse(jsonString);
  }

  //guarda la evaluación para el item
  public setLocalStorage(itemIdActual, value: string) {
    localStorage.setItem('EXAM_VAL_' + itemIdActual, value);
  }

  isPartOfList(type) {
    for (let elem of this.examEvaluationConf) {
      if (elem.tipo == type) return true;
    }
    return false;
  }

  //inicializa el objeto jsonObject
  public initializeJsonObject(user: string): Object {

    let jsonObject = {};
    let etiquetaValoracion = '';
    let etiquetaEvaluar = '';
    let elemValoracion = null;
    let elemEvaluar = null;
    let respuestaE = null;
    let controlOpc = 0;
    let mbControlOpc = false;

    //Recorre la primera parte de la evaluación correspondiente a criterios tipo ELEM : (Situacion/caso,Enunciado,Opcion A,Opcion B..)
    for (let i = 0; i < this.listaElementosValoracion.length; i++) {
      elemValoracion = this.listaElementosValoracion[i];
      etiquetaValoracion = elemValoracion.comentario ? elemValoracion.comentario : elemValoracion.etiqueta.substr(0, 4);
      mbControlOpc = false;

      //si el elemento de valoracion es una opcion de respuesta
      if (elemValoracion.etiqueta.toUpperCase().indexOf('OPCION') >= 0 ||
        elemValoracion.etiqueta.toUpperCase().indexOf('OPCIÓN') >= 0) {

        //cuenta la cantidad de opciones de respuesta
        controlOpc++;
        //setea la variable para saber si el elemento de valoración es de una opción de respuesta del Item
        mbControlOpc = true;
      }

      //Recorre los criterios de evaluación tipo EVAL: Pertinencia,Coherencia,Relevancia,Justificacion
      for (let j = 0; j < this.listaElementosEvaluar.length; j++) {
        elemEvaluar = this.listaElementosEvaluar[j];
        etiquetaEvaluar = elemEvaluar.comentario ? elemEvaluar.comentario : elemEvaluar.etiqueta.substr(0, 4);

        //Si el elemento de valoración es de una opción de respuesta del Item
        if (mbControlOpc) {
          //si se debe mostrar en el formulario
          if (controlOpc <= this.answersForEvaluation) {
            jsonObject[etiquetaValoracion + etiquetaEvaluar] = this.arrayObject.elementosValoracion[i][j].value;
          }
        }
        else {
          jsonObject[etiquetaValoracion + etiquetaEvaluar] = this.arrayObject.elementosValoracion[i][j].value;
        }

      }
    }

    //Recorre la segunda parte de la evaluación correspondiente a criterios tipo RETEX : (Indique cual es la respuesta correcta,clave, material de consulta, Justificaciòn General)
    for (let i = 0; i < this.listaRespuestasExtendias.length; i++) {
      respuestaE = this.listaRespuestasExtendias[i];
      jsonObject[respuestaE.comentario] = this.arrayObject.respuestasExtendias[i].value;
    }

    //pasa al objeto json, los datos de identificacion del usuario
    jsonObject['Identificacion'] = this._welcomeDataService.data.identificacion;
    jsonObject['Usuario'] = user;
    jsonObject['NombreUsuario'] = this._welcomeDataService.data.fullName;
    jsonObject['Ciudad'] = this._welcomeDataService.data.ciudad;

    return jsonObject;
  }

  public saveExamEvaluationItem(token: string, answer: Answer, user: string) {

    //Guarda las respuestas de la evaluación en la cache del navegador
    answer.respuestaAbierta = JSON.stringify(this.initializeJsonObject(user));
    this.setLocalStorage(answer.itemId, answer.respuestaAbierta);

    //validar si hay cambios en el formulario
    let elem: ExamItemEvaluation[];
    let elemVal: ExamItemEvaluation;
    let equals = true;
    for (let i = 0; i < this.oriArrayObject.elementosValoracion.length; i++) {
      elem = this.oriArrayObject.elementosValoracion[i];
      for (let j = 0; j < elem.length; j++) {
        if (elem[j].value !== this.arrayObject.elementosValoracion[i][j].value) {
          equals = false;
          break;
        }
      }
      if (!equals) break;
    }

    for (let i = 0; i < this.oriArrayObject.respuestasExtendias.length; i++) {
      elemVal = this.oriArrayObject.respuestasExtendias[i];
      if (elemVal.value !== this.arrayObject.respuestasExtendias[i].value) {
        equals = false;
        break;
      }
    }

    //si hay cambios en el formulario
    if (!equals) {
      //Invoca el servicio para guadar la evaluación de la prueba en base de datos
      this.saveExamEvaluation(token, answer, user);
    }
  }

  public validateForm(): ExamEvaluationValidationResponse {

    let evalElement: ExamEvaluationConfigurationDTO;
    let elementValoration: ExamEvaluationConfigurationDTO;
    let validElement: ExamEvaluationConfigurationDTO;
    let value: string = null;
    let lastIndx = null;
    let mbControlJusti: boolean;

    this.validationFormReset();
    let controlOpc = 0;
    let mbControlOpc: boolean;

    for (let i = 0; i < this.arrayObject.elementosValoracion.length; i++) {

      elementValoration = this.listaElementosValoracion[i];
      mbControlJusti = false;
      mbControlOpc = false;

      //si el elemento de valoracion es una opcion de respuesta
      if (elementValoration.etiqueta.toUpperCase().indexOf('OPCION') >= 0 ||
        elementValoration.etiqueta.toUpperCase().indexOf('OPCIÓN') >= 0) {
        //cuenta la cantidad de opciones de respuesta
        controlOpc++;
        //setea la variable para saber si el elemento de valoración es de una opción de respuesta del Item
        mbControlOpc = true;
      }

      if (!mbControlOpc || controlOpc <= this.answersForEvaluation) {

        for (let j = 0; j < this.arrayObject.elementosValoracion[i].length; j++) {

          value = this.arrayObject.elementosValoracion[i][j].value;
          evalElement = this.listaElementosEvaluar[j];

          //si es un tipo lista
          if (evalElement.listToSelect) {
            lastIndx = evalElement.listToSelect.length - 1;
            validElement = evalElement.listToSelect[lastIndx];
            if (value == 'Seleccione') {
              this.arrayObject.elementosValoracion[i][j].error = true;
              return new ExamEvaluationValidationResponse(false,
                "El campo a valorar <strong>" + elementValoration.etiqueta + "</strong> en el criterio <strong>" + evalElement.etiqueta + "</strong>  debe contener algún valor");
            }
            //si la respuesta no es la última en la selección
            if (value !== validElement.longitud && value !== validElement.etiqueta) {
              mbControlJusti = true;
            }
          }
          //si no es un tipo lista 
          else {
            if (mbControlJusti && (!value || value.trim().length == 0)) {

              this.arrayObject.elementosValoracion[i][j].error = true;

              return new ExamEvaluationValidationResponse(false,
                "El campo a valorar <strong>" + elementValoration.etiqueta + "</strong> en el criterio <strong>" + evalElement.etiqueta + "</strong>  debe contener algún valor");
            }
            else if (mbControlJusti && value.length > 120) {

              this.arrayObject.elementosValoracion[i][j].error = true;

              return new ExamEvaluationValidationResponse(false,
                "El campo a valorar <strong>" + elementValoration.etiqueta + "</strong> en el criterio <strong>" + evalElement.etiqueta + "</strong> debe contener un valor menor a 120 caracteres");
            }
          }
        }
      }
    }

    for (let i = 0; i < this.arrayObject.respuestasExtendias.length; i++) {
      value = this.arrayObject.respuestasExtendias[i].value;
      evalElement = this.listaRespuestasExtendias[i];
      if (!value || value.trim().length == 0) {
        this.arrayObject.respuestasExtendias[i].error = true;

        return new ExamEvaluationValidationResponse(false,
          "El campo a valorar <strong>" + evalElement.etiqueta + "</strong> debe contener algún valor");
      }
    }

    return new ExamEvaluationValidationResponse(true, "");
  }

  //restaura la clase a los elementos que tengan error
  public validationFormReset(indVal?, indElenVal?) {

    if (!this.arrayObject || !this.arrayObject.elementosValoracion || !this.arrayObject.respuestasExtendias) {
      return;
    }

    if ((indVal == null && indElenVal == null) || (indVal !== null && indElenVal !== null)) {
      for (let i = 0; i < this.arrayObject.elementosValoracion.length; i++) {
        if (indVal == i || indVal == null) {
          for (let j = 0; j < this.arrayObject.elementosValoracion[i].length; j++) {
            if (indElenVal == j || indElenVal == null) {
              this.arrayObject.elementosValoracion[i][j].error = null;
            }
          }
        }
      }
    }

    if ((indVal === null && indElenVal == null) || (indVal !== null && indElenVal == null)) {
      for (let i = 0; i < this.arrayObject.respuestasExtendias.length; i++) {
        if (indVal == i || indVal == null) {
          this.arrayObject.respuestasExtendias[i].error = null;
        }
      }
    }
  }

  disabledButtons(state) {

    if (this.visualizerComponent) {
      this.visualizerComponent.disabledEndTest = state;
      this.visualizerComponent.disabledNextBack = state;
      if (state) {
        if (!this.controlMessageInfo) {
          $('#offline-exam-evaluation-error').modal({
            show: 'true'
          });
        }

        this.controlMessageInfo = true;
      }
      else {
        this.controlMessageInfo = false;
      }

    }

  }
  private convertirTildesAHtml(texto) {
    const tildes = {
      'á': '&aacute;',
      'é': '&eacute;',
      'í': '&iacute;',
      'ó': '&oacute;',
      'ú': '&uacute;',
      'Á': '&Aacute;',
      'É': '&Eacute;',
      'Í': '&Iacute;',
      'Ó': '&Oacute;',
      'Ú': '&Uacute;',
      'à': '&agrave;',
      'è': '&egrave;',
      'ì': '&igrave;',
      'ò': '&ograve;',
      'ù': '&ugrave;',
      'À': '&Agrave;',
      'È': '&Egrave;',
      'Ì': '&Igrave;',
      'Ò': '&Ograve;',
      'Ù': '&Ugrave;',
      'ñ': '&ntilde;',
      'Ñ': '&Ntilde;',
      'â': '&acirc;',
      'ê': '&ecirc;',
      'î': '&icirc;',
      'ô': '&ocirc;',
      'û': '&ucirc;',
      'Â': '&Acirc;',
      'Ê': '&Ecirc;',
      'Î': '&Icirc;',
      'Ô': '&Ocirc;',
      'Û': '&Ucirc;',
      'ä': '&auml;',
      'ë': '&euml;',
      'ï': '&iuml;',
      'ö': '&ouml;',
      'ü': '&uuml;',
      'Ä': '&Auml;',
      'Ë': '&Euml;',
      'Ï': '&Iuml;',
      'Ö': '&Ouml;',
      'Ü': '&Uuml;'      
    };

    return texto.replace(/[áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙñÑâêîôûÂÊÎÔÛäëïöüÄËÏÖÜ]/g, (letra) => tildes[letra]);
  }


}

